const getSearchParams = () => new URLSearchParams(window.location.search);

const searchSystem = (system) => {
  if (!system) return false;

  //use search
  const search = getSearchParams().get('search');

  if (search) {
    return (
      system.system_name
        ?.toLowerCase()
        .replace(/\s/g, '')
        .includes(search.toLowerCase().replace(/\s/g, '')) ||
      system.system_type
        ?.toLowerCase()
        .replace(/\s/g, '')
        .includes(search.toLowerCase().replace(/\s/g, '')) ||
      (typeof system?.device_type === 'string' &&
        system.device_type
          ?.toLowerCase()
          .replace(/\s/g, '')
          .includes(search.toLowerCase().replace(/\s/g, '')))
    );
  } else return true;
};

const searchDeviceType = (type) => {
  //use search
  const search = getSearchParams().get('search');

  if (search) {
    return type.toLowerCase().replace(/\s/g, '').includes(search.toLowerCase().replace(/\s/g, ''));
  } else return true;
};

const searchDevice = (device) => {
  if (!device) return false;

  //use search
  const search = getSearchParams().get('search');
  if (search) {
    return (
      device.name
        .toLowerCase()
        .replace(/\s/g, '')
        .includes(search.toLowerCase().replace(/\s/g, '')) ||
      device.alias
        .toLocaleLowerCase()
        .replace(/\s/g, '')
        .includes(search.toLowerCase().replace(/\s/g, ''))
    );
  } else return true;
};

export const groupSearchFilter = (group, connectedDevices) => {
  if (!group) return false;

  //use search
  const search = getSearchParams().get('search');

  const devices = connectedDevices?.filter((device) => group.devices.includes(device.id)) || [];

  if (search) {
    return (
      group.name
        .toLowerCase()
        .replace(/\s/g, '')
        .includes(search.toLowerCase().replace(/\s/g, '')) ||
      devices
        .map(
          (device) =>
            device.name
              .toLowerCase()
              .replace(/\s/g, '')
              .includes(search.toLowerCase().replace(/\s/g, '')) ||
            device.alias
              .toLowerCase()
              .replace(/\s/g, '')
              .includes(search.toLowerCase().replace(/\s/g, '')),
        )
        .includes(true)
    );
  } else return true;
};

export const systemSearchFilter = (system, deviceTypes, connectedDevices) => {
  return (
    searchSystem(system) || //Check for system
    Object.keys(deviceTypes?.[system.system_type] || {}) //Check for any device types in system
      .map(
        (type) =>
          searchDeviceType(type) ||
          connectedDevices //Check for any devices in device type
            .filter((device) => device.device_type === type)
            .map((device) => searchDevice(device))
            .includes(true),
      )
      .includes(true)
  );
};

export const deviceTypeSearchFilter = (type, deviceData) => {
  if (!type) return false;

  const systemType = Object.keys(deviceData?.deviceTypes)?.find((systemType) =>
    Object.keys(deviceData?.deviceTypes?.[systemType] || {}).includes(type),
  );

  const system = deviceData?.integrations?.find((system) => system.system_type === systemType);

  return (
    searchSystem(system) ||
    searchDeviceType(type) ||
    deviceData.connectedDevices
      ?.filter((device) => device.device_type === type)
      .map((device) => searchDevice(device))
      .includes(true)
  );
};

export const deviceSearchFilter = (device, deviceData) => {
  const system = deviceData?.integrations?.find(
    (system) => system.system_type === device.system_type,
  );

  return searchSystem(system) || searchDeviceType(device.device_type) || searchDevice(device);
};
